// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2nKG4","cardHeader":"Card_cardHeader__9tnba"};